import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Awards from "../components/Awards";
import PopularCombos from "../components/PopularCombos";
import WhyBTW from "../components/WhyBTW";
import Community from "../components/Community";
import Catering from "../components/Catering";
import OrderSection from "../components/OrderSection";
import Footer from "../components/Footer";
import SectionDivider from "../components/SectionDivider";
import BackToTop from "../components/BackToTop";
import { SiteContentProvider } from "../data/SiteContentContext";

export default function Home() {
  return (
    <SiteContentProvider>
      <div className="bg-white text-[#0B0B0B] min-h-screen">
        <Header />
        <main>
          <Hero />
          <SectionDivider variant="dot" />
          <Awards />
          <PopularCombos />
          <WhyBTW />
          <SectionDivider variant="dot" />
          <Community />
          <Catering />
          <OrderSection />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </SiteContentProvider>
  );
}
